import * as AT from './actionTypes'

export type ResumeVerifyEmailActionType = {
  payload: { code: string; id: string }
  type: typeof AT.RESUME_EMAIL_VERIFICATION
}

export type ResendCodeActionType = {
  type: typeof AT.RESEND_CODE
}

export type SignupActionType = ResendCodeActionType | ResumeVerifyEmailActionType

const resendCode = (): SignupActionType => ({
  type: AT.RESEND_CODE
})

const resumeEmailVerification = (id: string, code: string): SignupActionType => ({
  payload: { code, id },
  type: AT.RESUME_EMAIL_VERIFICATION
})

export default {
  resendCode,
  resumeEmailVerification
}
